// extracted by mini-css-extract-plugin
export var bounce = "_o2-1";
export var generatingText = "_o2-6";
export var lightning = "_o2-4";
export var popup = "_o2-5";
export var progressBar = "_o2-7";
export var progressFill = "_o2-8";
export var progressShimmer = "_o2-9";
export var progressText = "_o2-a";
export var shimmer = "_o2-3";
export var uploadIcon = "_o2-0";
export var uploadingText = "_o2-2";